<app-action-button
  (addEvent)="create()"
  [isDeleteAction]="isDeleteAction"
  (deleteEvent)="openConfirm($event)"
  [hidden]="!authorizationService.canCreateOIDCAudience()"
  >
</app-action-button>

@if (isLoading) {
  <app-loading-indicator [isLoading]="isLoading" class="load-indicator" id="oidcAudiencesPage"></app-loading-indicator>
}
<div class="area data-table" id="ItemsArea">
  <app-noitems
    (clickEmit)="create()"
    [image]="'No_Clients'"
    [isEmpty]="showNoData"
    [typeName]="'oidc audiences.'"
  ></app-noitems>

  @if (filterApplied || (oidcAudiences.length > 0 && !isLoading) || filterHasChanged || changedPage) {
    <app-data-table
      (filterChanged)="filterChanged.bind(this)"
      [columnDefinitions]="columnDefs"
      [columnFilters]="columnFilters"
      [rowData]="oidcAudiences"
      [tableId]="'oidc-audiences'"
      [toggleItem]="toggle.bind(this)"
      [toggleAll]="toggleAll.bind(this)"
      [deleteItem]="deleteSingleItem.bind(this)"
      [openItem]="open.bind(this)"
    ></app-data-table>
  }
</div>
